export default __webpack_public_path__ + "static/media/sedacion_analgesia_delirium.48db9ce2.pdf";